import { h } from "preact";

import { SubscriptionPlan } from "../../../foundation/api/model";

import { PlanGroup } from "../../../foundation/enums";
import { pluralize } from "../../../foundation/utils/string";

import styles from "./PlanInfo.module.css";

interface Props {
    selectedPlan: SubscriptionPlan;
    personalPlanTier?: number;
}

export function getPlanInfoListItems(selectedPlan: SubscriptionPlan, freePlanTier?: number) {
    if (selectedPlan.group === "basic") {
        const planTier = selectedPlan.tiers!.find(t => t.quantity === freePlanTier)!;

        return [
            `Up to ${pluralize(planTier.projectLimit, "project")}`,
            "Unlimited users"
        ];
    } else if (selectedPlan.group === PlanGroup.ADVANCED) {
        return [
            `Up to ${pluralize(selectedPlan.projectLimit, "project")}`,
            "Pay-per-seat for Developers, Editors and higher",
            "Unlimited reviewers"
        ];
    }

    return [];
}

export default function PlanInfo({ selectedPlan, personalPlanTier }: Props) {
    return (
        <div class={styles.planInfoContainer}>
            <div class="body-1 medium">Plan</div>
            <div className={styles.planInfo}>
                <div className="body-1">{selectedPlan.name} {(selectedPlan.group === PlanGroup.BASIC && personalPlanTier) ?? ""}</div>
                <ul>
                    {getPlanInfoListItems(selectedPlan, personalPlanTier).map(planItem => (<li>{planItem}</li>))}
                </ul>
            </div>
        </div>
    );
}
